<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="打标签"
      id-key="Id"
      show-save-button
      :data="data"
      :form-rules="rules"
      :save-func="api.batchTag"
      @create-opened="onCreateOpened"
    >
      <template slot="form">
        <el-form-item label="用户标签" prop="TagId">
          <el-select v-model="data.TagId">
            <el-option v-for="i in tags" :key="i.id" :value="i.id" :label="i.name"></el-option>
          </el-select>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        TagId: null, //微信平台 个性化菜单
        Ids: [],
      },
      tags: [],
      api: require("@/api/fa/teacher").default,
      wxapi: require("@/api/sy/wxmenu").default,
      isMB: this.$store.state.isMB,
      rules: {
        TagId: [{ required: true, message: "请选择用户标签" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.wxapi.getWxTags().then((res) => {
        if (res.Data) this.tags = res.Data.tags;
        console.log("tags", this.tags);
      });
    },
  },
};
</script>
<style lang="scss">
</style>